const SizedBox = ({ height = 0, width = 0 }) => {
  return <div style={{ height, width }} />;
};

export default SizedBox;
